const KEY = process.env.REACT_APP_STRIPE_KEY
export { KEY }
